export default __webpack_public_path__ + "static/media/frames001.eeb5294c.jpeg";